"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListInappropriateKeywordsResponseSchema = exports.ListInappropriateKeywordsQuerySchema = exports.CreateInappropriateKeywordResponseSchema = exports.CreateInappropriateKeywordBodySchema = exports.InappropriateKeywordResponseSchema = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.InappropriateKeywordResponseSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    text: ruby_1.KeywordSchema,
});
exports.CreateInappropriateKeywordBodySchema = (0, core_1.StrictObject)({
    text: ruby_1.KeywordSchema,
});
exports.CreateInappropriateKeywordResponseSchema = exports.InappropriateKeywordResponseSchema;
exports.ListInappropriateKeywordsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListInappropriateKeywordsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.InappropriateKeywordResponseSchema);
